import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import {message} from 'antd';

function confermaDati(uuid,apiPath){
  return (dispatch) => {
    API.getAxios(apiPath).post(`/pratica/${uuid}/conferma`)
      .then(response => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'preventivatore_richiesta_inviata'});
        dispatch({ type: actionTypes.SAVE_DATA, payload: response.data});
        dispatch({ type: actionTypes.STEP_AVANTI_CONFERMA});
        dispatch({type: actionTypes.LOADING_CONFERMA_FALSE});
      })
      .catch(errore => { 
        dispatch({type: actionTypes.LOADING_CONFERMA_FALSE});
        if(Array.isArray(errore.response.data)) {
          errore.response.data.forEach(error => {
            message.error(`Errore ${error.errorCode}: ${error.errorMessage}`,15);
          });
        } else {
          message.error(`Errore ${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
        }
      })
  };
}

export default confermaDati;